import React from "react";
import Ebook3D from "./Ebook3D";
import { PRICE_LABEL, startCheckout } from "@/lib/checkout";
import { Button } from "./ui/button";
import { T } from "@/constants/testIds";
import { motion } from "framer-motion";

export default function FinalCTA() {
  return (
    <section className="relative py-24 md:py-40 bg-black border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 h-[400px] w-[800px] bg-red-700/30 blur-[150px] rounded-full" />
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black to-transparent" />
      </div>
      <div className="relative mx-auto max-w-[1200px] px-5 md:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="flex items-center justify-center gap-3 mb-6"
        >
          <span className="h-[1px] w-10 bg-red-600" />
          <span className="eyebrow">Finalização · Vol. 01</span>
          <span className="h-[1px] w-10 bg-red-600" />
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="font-display font-black leading-[0.9] tracking-[-0.03em] text-5xl md:text-8xl text-neutral-50 mb-10 max-w-4xl mx-auto"
        >
          Conheça o <span className="text-red-600 italic">dossiê</span> completo.
        </motion.h2>
        <p className="text-neutral-400 max-w-xl mx-auto text-base md:text-lg">
          Uma leitura organizada sobre acontecimentos que marcaram a política brasileira recente.
        </p>

        <div className="mt-16 mb-10 flex justify-center">
          <Ebook3D />
        </div>

        <div className="font-display font-black text-neutral-50 text-7xl md:text-9xl leading-none mb-8">
          {PRICE_LABEL}
        </div>
        <Button
          data-testid={T.finalBuy}
          onClick={startCheckout}
          className="btn-pulse h-16 bg-red-600 hover:bg-red-700 text-white rounded-sm px-10 font-mono tracking-[0.3em] text-[13px] uppercase"
        >
          Quero meu ebook
        </Button>
        <p className="mt-6 font-mono text-[10px] tracking-[0.25em] uppercase text-neutral-600">
          Pagamento processado por Stripe · Download imediato em PDF
        </p>
      </div>
    </section>
  );
}
